import React from 'react'

export default function LocationIcon (props) {
  return (
    <svg x='0px' y='0px' width='16px' height='16px' viewBox='0 0 16 16'>
      <g>
        <circle fill='currentColor' cx='8' cy='7' r='2' />
        <path fill='currentColor' d='M7.3,15.7c-0.1-0.1-4.2-3.7-4.2-3.8C1.7,10.7,1,8.9,1,7c0-3.9,3.1-7,7-7s7,3.1,7,7c0,1.9-0.7,3.7-2.1,5
    c-0.1,0.1-4.1,3.7-4.2,3.8C8.3,16.1,7.7,16.1,7.3,15.7z M4.6,10.7l3.4,3l3.4-3c0,0,0,0,0,0c1-1,1.6-2.2,1.6-3.6c0-2.8-2.2-5-5-5
    S3,4.2,3,7C3,8.4,3.6,9.7,4.6,10.7C4.6,10.6,4.6,10.6,4.6,10.7z' />
      </g>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./components/Customers/icons/location.js